import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';


import { login, loginVariables } from './types/login';

@Injectable({ providedIn: 'root' })
export class UserLoginGQL extends Query<login, loginVariables> {
  document = gql`
    query login($email: String!, $password: String!) {
      login(email: $email, password: $password) {
        email
        token
      }
    }
  `;
}